<div class="layout-wrapper" [class.sidebar--collapse]="!isSidebarOpen()">

  <div>

    <nav  smsir-sidebar [isOpen]="isSidebarOpen()" [creditAmount]="32000000" [creditMessages]="132250"
         (closed)="onSidebarToggle(false)">

      <ng-container sidebar-menu>
        <smsir-divider></smsir-divider>
        <smsir-sidebar-spacer></smsir-sidebar-spacer>

        <smsir-sidebar-menu-item
          [icon]="'ic-settings-widget-5'"
          [routerLink]="'/dashboard'"
          (itemSelect)="onSidebarToggle(false)"
        >
          صفحه اصلی
        </smsir-sidebar-menu-item>

        <smsir-sidebar-spacer></smsir-sidebar-spacer>

        @for (group of visibleGroups(); track group.id) {
          <smsir-sidebar-menu-group
            [title]="group.title"
            [isOpen]="group.isOpen ?? true"
            [disabled]="group.disabled ?? false"
            [badge]="group.badge ?? false"
          >
            @for (item of group.items; track item.id) {
              <smsir-sidebar-menu-item
                [routerLink]="item.routerLink"
                [routerLinkOptions]="item.routerLinkOptions ?? exactSidebarMatch"
                [disabled]="item.disabled ?? false"
                [count]="item.count ?? null"
                [dot]="item.dot ?? false"
                [icon]="item.icon ?? ''"
                [hasPinned]="item.hasPinned ?? true"
                (itemSelect)="onSidebarToggle(false)"
              >
                {{ item.label }}
              </smsir-sidebar-menu-item>
            }
          </smsir-sidebar-menu-group>

          <smsir-sidebar-spacer></smsir-sidebar-spacer>
        }
      </ng-container>

      <smsir-sidebar-user
        (themeSelected)="onThemeToggle($event)"
        sidebar-footer
        [activeTheme]="theme()"
        [plan]="'پنل مبتدی | 358 روز تا پایان'"
        [name]="'کاربر سامانه'">

<!--        [avatarUrl]="userImage"-->
        <smsir-sidebar-menu-item [hasPinned]="false" icon="ic-notifications-bell" (itemSelect)="onSidebarToggle(false)">گزارش‌ها</smsir-sidebar-menu-item>
        <smsir-sidebar-menu-item [hasPinned]="false" icon="ic-money-ticker-star" (itemSelect)="onSidebarToggle(false)">امتیازات</smsir-sidebar-menu-item>
        <smsir-sidebar-menu-item [hasPinned]="false" icon="ic-security-shield-warning" (itemSelect)="onSidebarToggle(false)">احراز هویت
        </smsir-sidebar-menu-item>
        <smsir-sidebar-menu-item [destructive]="true" [hasPinned]="false" icon="ic-arrows-alogout-2-logout-2" (itemSelect)="onLogout()">خروج از
          حساب
        </smsir-sidebar-menu-item>

      </smsir-sidebar-user>

    </nav>

  </div>

  <div class="layout-topbar" [class.layout-topbar--sticky]="isScrolled()">

    <div class="layout-topbar-inner">

      <div>
        @if (showRegistrationExitButton()) {
          <button
            type="button"
            smsir-button
            size="sm"
            variant="text"
            (click)="onRegistrationSaveAndExit()"
          >
            <i class="ic-linear ic-arrows-arrow-right"></i>
            ذخیره و خروج
          </button>
        }
      </div>

      <button smsir-button size="md" variant="text" iconOnly (click)="onSidebarToggle(true)">
        <i class="ic-linear ic-ui-essentional-hamburger-menu text-[var(--smsir-font-3xl)]"></i>
      </button>


    </div>

  </div>

  <div class="content-wrapper">
    <router-outlet></router-outlet>
  </div>

</div>





